import React, { Fragment } from "react";
import SEO from "../../components/seo";
import HeaderTwo from "../../wrappers/HeaderTwo";
import DashboardSidebar from "./DashboardSidebar";
import Footer from "../../wrappers/Footer";
import "../../assets/css/dashboard.css";
import bg from "../../assets/images/Others/my-account.png";

const DashboardLayout = ({ children, pageClass }) => {
  return (
    <Fragment>
      <SEO titleTemplate="Dashboard" />
      <HeaderTwo />
      <div className="dashboard_wrapper">
        <DashboardSidebar />
        <div className={`wrapper_page_con ${pageClass || ""}`}>
          <div className="wrapper_inner_con">{children}</div>
        </div>
      </div>
      <img src={bg} alt="Hero" className="desktop_image" />
      <Footer />
    </Fragment>
  );
};

export default DashboardLayout;
